import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Chevron } from '@jutro/components';
import { Accordion, AccordionCard, InputField, Button, CurrencyField } from '@jutro/legacy/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { UWBlockingPoint } from 'wmic-pe-portals-edge-validation-js';
import styles from './QuoteClauseTable.module.scss';
import QuoteTableAccordionCardIterableComponent from '../QuoteTableAccordionCardIterableComponent/QuoteTableAccordionCardIterableComponent';
import WMICUnderwritingIssues from '../WMICUnderwritingIssues/WMICUnderwritingIssues';
import metadata from './QuoteClauseTable.metadata.json5';

const BLOCKS_QUOTES = [UWBlockingPoint.BLOCKS_QUOTE, UWBlockingPoint.BLOCKS_QUOTE_RELEASE];

function QuoteClauseTableView({
    breakpoint,
    formData,
    onValidationChange,
    onValueChange,
    overrideProps,
    quoteData,
    blockingUWIssuesHideCoverages,
}) {
    const { underwritingIssues, quoteID, filterUWIssuesInCustomOffering } = quoteData;
    const findBlockingPoint = useCallback(
        () => underwritingIssues.some(offeringIssue => BLOCKS_QUOTES.includes(offeringIssue.currentBlockingPoint)),
        [underwritingIssues]
    );

    const mergedOverrideProps = {
        '@field': {
            // apply to all fields
            onValueChange,
        },
        underWritingIssues: {
            underwritingIssues,
            blockQuote: findBlockingPoint(),
            quoteID,
            filterUWIssuesInCustomOffering,
        },
        paymentToggle: {
            visible: !blockingUWIssuesHideCoverages || !findBlockingPoint(),
        },
        tableContainer: {
            visible: !blockingUWIssuesHideCoverages || !findBlockingPoint(),
        },
        tableHeader: {
            visible: !blockingUWIssuesHideCoverages || !findBlockingPoint(),
        },
        ...overrideProps,
    };

    const formMetadata = useMemo(() => {
        const {
            componentContent: { content },
        } = metadata;

        if (breakpoint === 'phoneWide' || breakpoint === 'phone') {
            return content.filter(item => item.id !== 'desktopTable');
        }

        return content.filter(item => item.id !== 'phoneTable' && item.id !== 'mobileAccordionHeader');
    }, [breakpoint]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            chevron: Chevron,
            quotetableaccordioncarditerablecomponent: QuoteTableAccordionCardIterableComponent,
            underwritingissues: WMICUnderwritingIssues,
            Accordion,
            AccordionCard,
            InputField,
            Button,
            CurrencyField,
        },
    };

    return (
        <ViewModelForm
            uiProps={formMetadata}
            model={formData}
            overrideProps={mergedOverrideProps}
            onValueChange={onValueChange}
            onValidationChange={onValidationChange}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

QuoteClauseTableView.propTypes = {
    breakpoint: PropTypes.string.isRequired,
    formData: PropTypes.object.isRequired,
    onValidationChange: PropTypes.func.isRequired,
    onValueChange: PropTypes.func.isRequired,
    overrideProps: PropTypes.object.isRequired,
    quoteData: PropTypes.object.isRequired,
    blockingUWIssuesHideCoverages: PropTypes.bool,
};

QuoteClauseTableView.defaultProps = {
    blockingUWIssuesHideCoverages: false,
};

export default QuoteClauseTableView;
